import { render, staticRenderFns } from "./BetgameType.vue?vue&type=template&id=730340f3&scoped=true"
import script from "./BetgameType.vue?vue&type=script&lang=js"
export * from "./BetgameType.vue?vue&type=script&lang=js"
import style0 from "./BetgameType.vue?vue&type=style&index=0&id=730340f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730340f3",
  null
  
)

export default component.exports